import {Button}                                                                            from "components/Buttons";
import {StickyMenu}                                                                        from "components/StickyMenu";
import {ViewMore}                                                                          from "components/ViewMore";
import React                                                                               from "react";
import {Icon}                                                                              from "./styles";
import {LogoWrapper}                                                                       from "./styles";
import {ButtonWrapper, Container, Header, Image, Mask, Text, TextBox, TextWrapper, Title,} from "./styles";

export const BigHero = ({data}) => (
  <>
    <Container>
      <Mask color={data.color}/>
      <Image alt="">{data.image}</Image>
      <TextBox>
        <TextWrapper>
          {
            data.title && (
              <Title color={data.textColor}>{data.title}</Title>
            )
          }
          {
            data.icon && (
              <LogoWrapper>
                <Icon src={data.icon}/>
              </LogoWrapper>
            )
          }
          <Header color={data.textColor} spanColor={data.spanColor} as={data.title ? "h2" : "h1"}>{data.header}</Header>
          <Text color={data.textColor} biggerSize={data.biggerSize}>{data.text}</Text>
          {
            data.button && (
              <ButtonWrapper>
                <Button
                  href={data.button.href}
                  target="_blank"
                  title="Zobacz portfolio fotograficzne"
                  rel="noopener"
                >
                  {data.button.title}
                </Button>
              </ButtonWrapper>
            )
          }
        </TextWrapper>
      </TextBox>
      <ViewMore color={data.textColor}/>
    </Container>
    {data.menu && <StickyMenu data={data.menu}/>}
  </>
);
